<script setup>
import { useI18n } from 'vue-i18n';
import Avatar from 'dashboard/components-next/avatar/Avatar.vue';

defineProps({
  empresa: {
    type: Object,
    required: true,
  },
});

defineEmits(['select']);

const { t } = useI18n();
</script>

<template>
  <div
    class="flex items-center gap-3 px-6 py-2.5 transition-colors cursor-pointer group hover:bg-n-alpha-1"
    role="button"
    tabindex="0"
    @click="$emit('select', empresa)"
    @keyup.enter="$emit('select', empresa)"
  >
    <Avatar :name="empresa.name" :size="36" />

    <!-- Identity -->
    <div class="flex flex-col min-w-0">
      <span class="text-sm font-medium truncate text-n-slate-12">
        {{ empresa.name }}
      </span>
      <span
        v-if="empresa.email_domain"
        class="text-xs truncate text-n-slate-10"
      >
        {{ empresa.email_domain }}
      </span>
    </div>

    <!-- Website (subtle, hidden on small screens) -->
    <span
      class="hidden flex-1 min-w-0 px-2 text-xs truncate sm:block text-n-slate-10"
    >
      {{ empresa.website || '' }}
    </span>

    <!-- Contacts count pill -->
    <span
      class="flex items-center gap-1 px-2 py-0.5 ml-auto text-xs rounded-md shrink-0 sm:ml-0 bg-n-alpha-1 text-n-slate-11"
      :title="t('EMPRESAS.FIELDS.CONTACTS_COUNT')"
    >
      <span class="i-lucide-users size-3.5" />
      {{ empresa.contacts_count || 0 }}
    </span>

    <!-- Affordance -->
    <span
      class="i-lucide-chevron-right size-4 shrink-0 text-n-slate-8 transition-colors group-hover:text-n-slate-10"
    />
  </div>
</template>
